import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6aa7be380a1ed80014dc8853_1789392236103_ffc343c5/zecbit/src/app/collections/page.tsx");
